export const registrationLinkEmailUtmParameters = "?utm_source=link&utm_medium=email&utm_campaign=course-registration-email"
